import { BASE_URL } from "./variables";

export const toggleServiceEvv = async (serviceId, enabled = 1) => {
  try {
    const response = await fetch(`${BASE_URL}/toggle-service-evv`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjE1MzAxMCwiYnVzaW5lc3NJZCI6MTA0NzAsIk1lbWJlcklEIjoxNDU3MTcsInVzZXJuYW1lIjoic2VjdXJlLmFkbWluIiwiZmlyc3ROYW1lIjoiU3VwcG9ydCIsImxhc3ROYW1lIjoiQW5rb3RhIiwiYXBpQWNjZXNzIjpmYWxzZSwiZXhwIjoyNTM0MDIyMTQ0MDB9.fJaUKmFT1cv_AP-FGX-I8tBArpzMD5DF9l3-zqHY6aU'
      },
      body: JSON.stringify({ ServiceId: serviceId, Enabled: enabled })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('toggleServiceEvv API call failed:', error);
    throw error;
  }
};

export default toggleServiceEvv;
